import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReceiptCancellationComponent } from './receipt-cancellation/receipt-cancellation.component';
import { ReceiptCancellationlandingComponent } from './receipt-cancellationlanding/receipt-cancellationlanding.component';
import { ReceiptCancellationlinkComponent } from './receipt-cancellationlink/receipt-cancellationlink.component';

const routes: Routes = [
 
    {
      path:'',component:ReceiptCancellationlinkComponent,
      children:[
        {
          path:"ReceiptCancellationApproval",component:ReceiptCancellationlandingComponent,
        },
      ]
    }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReceiptCancellationRoutingModule { }
